import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "😵", key: "cantVisualize" },
  { emoji: "😩", key: "overwhelmed" },
  { emoji: "💸", key: "costlyMistakes" },
  { emoji: "🔄", key: "clutterReturns" },
]

export default function HomeBiggestPainPage() {
  return (
    <RadioCardListPage translationKey="homeBiggestPain" options={OPTIONS} />
  )
}
